import { Page } from '../types';

export interface RouteConfig {
    title: string;
    subtitle?: string;
}

export const ROUTE_CONFIGS: Partial<Record<Page, RouteConfig>> = {
    dashboard: {
        title: 'Dashboard',
        subtitle: 'Visão geral do seu negócio.'
    },
    chat: {
        title: 'Conversas',
        subtitle: 'Responda e gerencie suas conversas facilmente'
    },
    kanban: {
        title: 'Negociações',
        subtitle: 'Acompanhe suas oportunidades.'
    },
    contacts: {
        title: 'Contatos',
        subtitle: 'Todos os contatos dos seus leads.'
    },
    products: {
        title: 'Produtos',
        subtitle: 'Gerencie os produtos ou serviços.'
    },
    tasks: {
        title: 'Tarefas',
        subtitle: 'Gerencie suas tarefas e pendências.'
    },
    subscription: {
        title: 'Planos e Preços',
        subtitle: 'Escolha o plano perfeito para o crescimento do seu negócio.'
    },
    onboarding: {
        title: 'Configuração inicial',
        subtitle: 'Complete os passos para começar a usar o Adlitics.'
    },

    profile: {
        title: 'Meu Perfil',
        subtitle: 'Gerencie suas informações pessoais e configurações'
    },
    settings: {
        title: 'Configurações',
        subtitle: 'Escolha uma seção para gerenciar.'
    },
    team: {
        title: 'Membros da Equipe',
        subtitle: 'Gerencie quem tem acesso à sua organização'
    },
    monitoring: {
        title: 'Utilização',
        subtitle: 'Acompanhe o consumo de recursos e limites do seu plano.'
    },
    connections: {
        title: 'Canais de Atendimento',
        subtitle: 'Conecte e gerencie seus números de WhatsApp.'
    },
    tracking: {
        title: 'Integrações',
        subtitle: 'Configure integrações externas e pixels de rastreamento.'
    },
    billing: {
        title: 'Faturamento',
        subtitle: 'Histórico de pagamentos e notas fiscais.'
    },

    'settings-tags': {
        title: 'Etiquetas',
        subtitle: 'Gerencie etiquetas para segmentar seus contatos.'
    },
    'settings-quick-replies': {
        title: 'Respostas Rápidas',
        subtitle: 'Crie modelos de mensagens para agilizar o atendimento.'
    },
    'settings-pix': {
        title: 'Chave PIX',
        subtitle: 'Cadastre a chave PIX da organização para o chat.',
    },
    'settings-loss-reasons': {
        title: 'Motivos de Perda',
        subtitle: 'Defina os motivos pelos quais as negociações são perdidas.'
    },
    'settings-origins': {
        title: 'Origem de Leads',
        subtitle: 'Gerencie as fontes de entrada dos seus leads.'
    },
    'settings-webhooks': {
        title: 'Webhooks',
        subtitle: 'Integre seu sistema enviando dados para outras plataformas.'
    },
    'follow-up': {
        title: 'Follow-up Automático',
        subtitle: 'Configure mensagens automáticas para reativar leads'
    },
    'edit-funnel': {
        title: 'Funil de Venda',
        subtitle: 'Configure as etapas do seu pipeline e conecte nos eventos de conversão'
    },
    'create-funnel': {
        title: 'Novo Funil',
        subtitle: 'Crie um novo funil de vendas com etapas personalizadas'
    }
};

export const getRouteConfig = (page: Page): RouteConfig => {
    return ROUTE_CONFIGS[page] || {
        title: ''
    };
};
